<template>
  <div>
    <div class="bg-body"/>
    <div v-if="purcentage === -1">
      <DashboardHeader v-if="statut !=='VAE'" :profile-picture-url="profilePictureUrl" :subtitle="subtitle" :title="title"/>
      <div class="dashboard-status" v-if="statut !=='VAE'">
        <div class="dashboard-status-content">
          <div class="dashboard-status-content-label">
            Chargement...
          </div>
          <div class="dashboard-status-content-progress">
            <ve-progress
                :progress="progress"
                :size="100"
                color="#CBDB2A"
                emptyThickness="10%"
                line="square"
                thickness="10%"
            >
              <span class="dashboard-status-content-progress-legend">{{ progress }}%</span>
            </ve-progress>
          </div>
        </div>
      </div>
    </div>

    <DashboardNoCandidature v-if="purcentage == 0 & statut != 'Refusé'"
                            :comments=comments
                            :firstname=firstName
                            :ofVacationDateAsString=ofVacationDateAsString
                            :profile-picture-url=profilePictureUrl
                            :purcentage=purcentage
    />
    <DashboardVAE v-else-if="statut === 'VAE'"/>
    <DashboardExpired v-else-if="purcentage == 1"
                      :comments=comments
                      :firstname=firstName
                      :ofVacationDateAsString=ofVacationDateAsString
                      :profile-picture-url=profilePictureUrl
                      :purcentage=purcentage
    />
    <DashboardCandidatureSaved v-else-if="purcentage == 20"
                               :comments=comments
                               :firstname=firstName
                               :ofVacationDateAsString=ofVacationDateAsString
                               :profile-picture-url=profilePictureUrl
                               :purcentage=purcentage
    />
    <DashboardEligibleCandidature v-else-if="purcentage == 50"
                                  :comments=comments
                                  :dayRemaining=dayRemaining
                                  :firstname=firstName
                                  :ifCVbase=ifCVbase
                                  :ifDayPlusTwo=ifDayPlusTwo
                                  :ifDeadlinePassed=ifDeadlinePassed
                                  :ofVacationDateAsString=ofVacationDateAsString
                                  :profile-picture-url=profilePictureUrl
                                  :purcentage=purcentage
                                  :statut=statut
                                  :textDateLimitTest=textDateLimitTest
    />
    <DashboardQualifying v-else-if="purcentage == 70"
                         :comments=comments
                         :firstname=firstName
                         :ofVacationDateAsString=ofVacationDateAsString
                         :profilViewedCount=profilViewedCount
                         :profile-picture-url=profilePictureUrl
                         :purcentage=purcentage
                         :statutEntretien=statutEntretien
                         :textCampusConvocation=textCampusConvocation
                         :textDateConvocation=textDateConvocation
    />
    <DashboardQualified v-else-if="purcentage == 85"
                        :comments=comments
                        :firstname=firstName
                        :ofVacationDateAsString=ofVacationDateAsString
                        :profilViewedCount=profilViewedCount
                        :profile-picture-url=profilePictureUrl
                        :purcentage=purcentage
    />
    <DashboardEnrollment v-else-if="purcentage == 95"
                         :comments=comments
                         :firstname=firstName
                         :ofVacationDateAsString=ofVacationDateAsString
                         :profile-picture-url=profilePictureUrl
                         :purcentage=purcentage
    />
    <DashboardRegistered v-else-if="purcentage == 100"
                         :comments=comments
                         :dateDebutContrat=dateDebutContrat
                         :dateDebutPromo="dateDebutPromo"
                         :dateEndContrat=dateEndContrat
                         :dateFinPromo="dateFinPromo"
                         :firstname=firstName
                         :ofVacationDateAsString=ofVacationDateAsString
                         :profile-picture-url=profilePictureUrl
                         :purcentage=purcentage
                         :textCampusRegistered=textCampusRegistered
                         :typeContrat=typeContrat
    />
    <DashboardRefuse v-else-if="purcentage == 0 & statut == 'Refusé'"
                     :comments=comments
                     :firstname=firstName
                     :ofVacationDateAsString=ofVacationDateAsString
                     :profile-picture-url=profilePictureUrl
                     :purcentage=0
    />

  </div>
</template>

<script>

import DashboardNoCandidature from '@/components/Dashboard/Type/NoCandidature.vue'
import DashboardCandidatureSaved from '@/components/Dashboard/Type/CandidatureSaved.vue'
import DashboardEligibleCandidature from '@/components/Dashboard/Type/EligibleCandidature.vue'
import DashboardQualifying from '@/components/Dashboard/Type/Qualifying.vue'
import DashboardQualified from '@/components/Dashboard/Type/Qualified.vue'
import DashboardEnrollment from '@/components/Dashboard/Type/Enrollment.vue'
import DashboardRegistered from '@/components/Dashboard/Type/Registered.vue'
import DashboardRefuse from '@/components/Dashboard/Type/Refuse.vue'
import DashboardExpired from '@/components/Dashboard/Type/Expired.vue'
import DashboardVAE from "@/components/Dashboard/Type/VAE.vue";
import DashboardHeader from "@/components/Dashboard/Header.vue";

import UserService from "@/services/user.service";
import {useGlobalStore} from "@/store/globalStore";

export default {
  name: "Dashboard",
  components: {
    DashboardVAE,
    DashboardHeader,
    DashboardNoCandidature,
    DashboardCandidatureSaved,
    DashboardEligibleCandidature,
    DashboardQualifying,
    DashboardQualified,
    DashboardEnrollment,
    DashboardRegistered,
    DashboardRefuse,
    DashboardExpired
  },
  data() {
    return {
      progress: 0,
      purcentage: -1,
      profilViewedCount: 0,
      firstName: '',
      ifCVbase: false,
      statut: '',
      comments: '',
      ofVacationDateAsString: '',

      textDateLimitTest: null,
      textDateConvocation: null,
      textCampusConvocation: null,
      textCampusRegistered: null,
      statutEntretien: null,

      typeContrat: 'Apprentissage',
      dateDebutContrat: '21/11/2021',
      dateEndContrat: '21/11/2023',
      dateDebutPromo: '',
      dateFinPromo: '',

      ifTest: false,
      ifDayPlusTwo: false,
      ifDeadlinePassed: false,
      ifContratR2: null,
      profilePictureUrl: null,
      title: "Bienvenue",
      subtitle: "Merci de patienter...",
    }
  },
  mounted() {
    let _ = this;
    this.progress = 0;

    this.progressTimer = window.setInterval(function () {
      if (_.progress < 100) {
        _.progress++
      } else {
        window.clearInterval(_.progressTimer);
      }
    }, 200);


    let redirectToMaintenance = window.setTimeout(function () {
      _.$store.dispatch('auth/logout');
      _.$router.push({name: 'public-maintenance'});
    }, 30000);

    UserService.getDashboardContent("Dashboard").then(
        (response) => {
          window.clearTimeout(redirectToMaintenance);
          if (response == false) {
            return
          }
          if ('VAE' === response.data.statut) {
            this.statut = 'VAE'
            this.subtitle = ''

            useGlobalStore().showFooter = false;
            window.clearInterval(_.progressTimer)
            return
          }
          let emailOnLogin = localStorage.getItem('emailOnLogin')

          if (null !== emailOnLogin) {
            if (emailOnLogin.toLowerCase().trim() !== response.data.email.toLowerCase().trim()) {
              _.$router.push({name: 'public-regenerate-email', params: {token: null, emailFrom: emailOnLogin, emailTo: response.data.email}});
            }
          }


          this.firstName = response.data.firstName
          this.ifCandidature = response.data.ifCandidature
          this.ifCVbase = response.data.ifCVbase
          this.statut = response.data.statut
          this.ifTest = response.data.ifTest
          this.textDateConvocation = response.data.dateEntretien
          this.textCampusConvocation = response.data.campusEntretien
          this.textCampusRegistered = response.data.campus
          this.typeContrat = response.data.typeContrat
          this.dateDebutContrat = response.data.debutContrat
          this.dateEndContrat = response.data.finContrat
          this.dateDebutPromo = response.data.debutPromo
          this.dateFinPromo = response.data.finPromo
          this.textDateLimitTest = response.data.textDateLimitTest
          localStorage.setItem('textLimitTest', this.textDateLimitTest)

          this.ifTestSend = response.data.ifTestSend
          this.statutEntretien = response.data.statutEntretien
          this.dateEntretien = response.data.dateEntretien
          this.ifContratR2 = response.data.ifContratR2
          this.dayRemaining = response.data.dayRemaining
          this.ifDeadlinePassed = response.data.ifDeadlinePassed
          this.ifDayPlusTwo = response.data.ifDayPlusTwo
          this.comments = response.data.comments
          this.ofVacationDateAsString = response.data.ofVacationDateAsString
          this.profilViewedCount = response.data.profilViewedCount
          this.profilePictureUrl = response.data.profilePictureUrl


          if (this.statut === '' || this.statut == null) {
            this.purcentage = 0
            // } else if (this.statut === 'Expiré' && !this.ifTestSend && this.textDateLimitTest) {
            //   this.purcentage = 50
          } else if (this.statut === 'Expiré') {
            this.purcentage = 1
          } else if (this.statut === 'Attente') {
            this.purcentage = 20
          } else if (this.statut === 'Publié' && !this.ifTestSend) {
            this.purcentage = 50
          } else if (this.statut === 'Publié' && this.ifTestSend && this.statutEntretien !== 'Oui') {
            this.purcentage = 70
          } else if (this.statut === 'Publié' && this.statutEntretien === 'Oui') {
            this.purcentage = 85
          } else if (this.statut === 'Abouti' && !this.ifContratR2) {
            this.purcentage = 95
          } else if (this.statut === 'Abouti' && this.ifContratR2) {
            this.purcentage = 100
          } else {
            this.purcentage = 0
          }
        },
        (error) => {
          window.clearTimeout(redirectToMaintenance);
        }
    );
  },
};
</script>
